import { createFileRoute } from "@tanstack/react-router";
import { SetTwoFactorRouteComponent } from "./-components/route";

export const Route = createFileRoute(
  "/auth/_auth-layout/set-two-factor/$twoFactorRequestId",
)({
  component: () => <SetTwoFactorRouteComponent />,
});
